import { render } from "./CreditRatings.vue?vue&type=template&id=2f898d8f&scoped=true"
import script from "./CreditRatings.vue?vue&type=script&lang=js"
export * from "./CreditRatings.vue?vue&type=script&lang=js"

import "./CreditRatings.vue?vue&type=style&index=0&id=2f898d8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f898d8f"]])

export default __exports__